import { render, staticRenderFns } from "./BaseFieldInput.vue?vue&type=template&id=8a0fec06&scoped=true&"
import script from "./BaseFieldInput.vue?vue&type=script&lang=js&"
export * from "./BaseFieldInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseFieldInput.vue?vue&type=style&index=0&id=8a0fec06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0fec06",
  null
  
)

export default component.exports